import { Controller } from '@hotwired/stimulus';
import { Modal } from 'bootstrap';

export default class extends Controller {
  static values = {
    modalUrl: String,
  };

  connect() {
    this.onClick = this.onClick.bind(this);
    this.pendingLoads = new Set();
    this.element.addEventListener('click', this.onClick);
  }

  disconnect() {
    this.element.removeEventListener('click', this.onClick);
  }

  onClick(event) {
    const trigger = event.target.closest('button[data-richtext-download-content-id]');
    if (!trigger) {
      return;
    }

    const contentId = trigger.getAttribute('data-richtext-download-content-id');
    if (!contentId || !/^\d+$/.test(contentId)) {
      return;
    }

    const modalId = `richtext-download-${contentId}`;

    event.preventDefault();

    const existing = document.getElementById(modalId);
    if (existing) {
      Modal.getOrCreateInstance(existing).show();
      return;
    }

    if (this.pendingLoads.has(contentId)) {
      return;
    }
    this.pendingLoads.add(contentId);

    const url = `${this.modalUrlValue}?id=${encodeURIComponent(contentId)}`;
    fetch(url, {
      credentials: 'same-origin',
      headers: { Accept: 'text/html' },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }
        return response.text();
      })
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
    
        const host = document.createElement('div');
        host.className = 'download-modals richtext-download-modals-host';
        host.setAttribute('aria-live', 'polite');
    
        host.replaceChildren(...doc.body.childNodes);
    
        document.body.appendChild(host);
    
        const modalEl = document.getElementById(modalId);
        if (!modalEl) {
            host.remove();
            return;
        }
    
        Modal.getOrCreateInstance(modalEl).show();
      })
      .catch((error) => {
        console.error('Failed to load download modal.');
      })
      .finally(() => {
        this.pendingLoads.delete(contentId);
      });
  }
}
